import {
    ADD_SCHOOLSESSION,
    UPDATE_SCHOOLSESSION,
    RESET_SCHOOLSESSIONS,
  } from "./schoolsessionActionTypes";
  
  // Add a new school session
  export const addSchoolSession = (session) => ({
    type: ADD_SCHOOLSESSION,
    payload: session,
  });
  
  // Update an existing school session
  export const updateSchoolSession = (sessionId, sessionData) => ({
    type: UPDATE_SCHOOLSESSION,
    payload: { sessionId, sessionData },
  });
  
  // Reset all school sessions
  export const resetSchoolSessions = () => ({
    type: RESET_SCHOOLSESSIONS,
  });
  